<template>
  <div class="page">
        <!-- 搜索 -->
  <el-form v-if="isSearch" :model="queryForm" ref="form" label-width="80px" :inline="true" size="small" class="query-form" @submit.native.prevent>
              <el-form-item label="用户">
                  <!-- <el-input  v-model="queryForm.userId"></el-input> -->
                  <GridSelectU title="选择用户" style="width: 177px;" labelName="userName" labelValue="id" :value="queryForm.userId" :limit='1'
                    size='small' placeholder='请选择用户' @getValue="getSeachValuebrandId" :columns="USER_code" :searchs="USER_search" dataListUrl="/mpp/user/findList" entityBeanName="mppUser" queryEntityUrl="/mpp/user/get">
                  </GridSelectU>
              </el-form-item>
              <el-form-item label="升级前等级">
                  <!-- <el-input style="width: 177px;" v-model="queryForm.originalGradeId"></el-input> -->
                  <el-select
                      style="width: 177px;"
                      clearable
                      v-model='queryForm.originalGradeId'
                      size='small'
                      placeholder='升级前等级'
                  >
                      <el-option v-for='(item,index) in mppGradeAll' :label='item.gradeName' :value='item.id'></el-option>
                  </el-select>
              </el-form-item>
              <el-form-item label="升级后等级">
                  <!-- <el-input style="width: 177px;" v-model="queryForm.upgradeGradeId"></el-input> -->
                  <el-select
                      style="width: 177px;"
                      clearable
                      v-model='queryForm.upgradeGradeId'
                      size='small'
                      placeholder='升级前等级'
                  >
                      <el-option v-for='(item,index) in mppGradeAll' :label='item.gradeName' :value='item.id'></el-option>
                  </el-select>
              </el-form-item>
              <el-form-item label="升级模式">
                  <!-- <el-input style="width: 177px;" v-model="queryForm.upgradeMode"></el-input> -->
                  <el-select
                      style="width: 177px;"
                      v-model='queryForm.upgradeMode'
                      size='small'
                      placeholder='升级模式'
                  >
                      <el-option v-for='(item,index) in upgradeModeTypeEnumList' :label='item.value' :value='item.key'></el-option>
                  </el-select>
              </el-form-item>
              <el-form-item label="支付方式">
                  <!-- <el-input style="width: 177px;" v-model="queryForm.payType"></el-input> -->
                  <el-select
                      style="width: 177px;"
                      v-model='queryForm.payType'
                      size='small'
                      placeholder='支付方式'
                  >
                      <el-option v-for='(item,index) in upgradePayUnitTypeEnumList' :label='item.value' :value='item.key'></el-option>
                  </el-select>
              </el-form-item>
              <el-form-item label="支付单号">
                  <el-input style="width: 177px;" v-model="queryForm.payNo"></el-input>
              </el-form-item>
              <el-form-item>
                  <el-button size="small" type="primary" icon="el-icon-search" @click="getMppGradeUplogList">查询</el-button>
                  <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
              </el-form-item>
  </el-form>
  <div class="page-content">
    <div class="page-tool-bar">
      <div class="el-btn-group">
        <el-button
          type="primary"
          size="small"
          icon="el-icon-plus"
          @click="addMppGradeUplog"
        >新建</el-button>
        <el-button
          type="warning"
          plain
          size="small"
          icon="el-icon-edit"
          :disabled="multipleSelection.length != 1"
          @click="editMppGradeUplog(null)"
        >修改</el-button>
        <el-button
          type="danger"
          plain
          size="small"
          icon="el-icon-delete"
          :disabled="multipleSelection.length <= 0"
          @click="deleteMppGradeUplog(null)"
        >删除</el-button>
      </div>

      <div class="icon-group">
            <el-upload v-if="this.isImportDate"
              class="upload-demo"
              action="#"
              :http-request="upload"
              :show-file-list="true">
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">只允许导入“xls”或“xlsx”格式文件！</div>
            </el-upload>
        <span
          title="搜索"
          class="icon-box"
          @click="search"
        >
          <Icon color="#606266">
            <Search />
          </Icon>
        </span>
        <span
          title="下载模板"
          class="icon-box"
          @click="importTemplate"
        >
          <Icon color="#606266">
            <ArrowDown />
          </Icon>
        </span>
        <span
          class="icon-box"
          title="导入数据"
          @click="isImport"
        >
          <Icon color="#606266">
            <ArrowExportUp24Regular />
          </Icon>
        </span>
        <span
          title="导出数据"
          class="icon-box"
          @click="exportMppGradeUplogList"
        >
          <Icon color="#606266">
            <ArrowDownload24Regular />
          </Icon>
        </span>
        <span
          class="icon-box"
          @click="refreshMppGradeUplogList"
        >
          <Icon color="#606266">
            <Refresh />
          </Icon>
        </span>
      </div>
    </div>
          <!-- 列表数据 -->
    <el-table
      :data="mppGradeUplogList"
      row-key="id"
      border
      height="100%"
      :header-row-style="{height: '10px'}"
      :header-cell-style="{padding: '10px'}"
      :row-style="{height: '9px'}"
      :cell-style="{padding: '9px'}"
      @selection-change="handleSelectionChange"
      size="small"
    >
      <el-table-column
        align="center"
        type="selection"
        width="60"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="userId"
        label="用户"
        width="180"
      > 
          <template slot-scope='scope'>
              <div v-if="scope.row.user">
                <div style='text-align: left'>账号：{{ scope.row.user.userName }}</div>
                <div style='text-align: left'>手机：{{ scope.row.user.userMobile }}</div>
                <div style='text-align: left'>昵称：{{ scope.row.user.userNickname }}</div>
                <div style='text-align: left'>姓名：{{ scope.row.user.userRealname }}</div>
              </div>
              <div v-else>--</div>
          </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="originalGradeId"
        label="升级前等级"
        width="180"
      > 
        <template slot-scope="scop">
          <div v-if="scop.row.grade1">
            <div>{{ scop.row.grade1.gradeName }}</div>
          </div>
          <div v-else>--</div>
        </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="upgradeGradeId"
        label="升级后等级"
        width="180"
      >
        <template slot-scope="scop">
          <div v-if="scop.row.grade2">
            <div>{{ scop.row.grade2.gradeName }}</div>
          </div>
          <div v-else>--</div>
        </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="upgradeMode"
        label="升级模式"
        width="180"
      > 
        <template slot-scope="scop">
          {{ getUpgradeModeType(scop.row.upgradeMode) }}
        </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="payType"
        label="支付方式"
        width="180"
      >
        <template slot-scope="scop">
          {{ componentUpgradePayUnitType(scop.row.payType) }}
        </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="payNo"
        label="支付单号"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="createTime"
        label="创建时间"
        width="180"
      > </el-table-column>
      <el-table-column
        fixed="right"
        align="center"
        label="操作"
        width="300"
      >
        <template slot-scope="scop">
          <div class="operation">
            <div @click="checkMppGradeUplog(scop.row.id)">
              <Icon size="16">
                <Eye24Regular />
              </Icon>
              <span class="operation-label">查看</span>
            </div>
            <div @click="editMppGradeUplog(scop.row.id)">
              <Icon size="16">
                <Edit24Regular />
              </Icon>
              <span class="operation-label">修改</span>
            </div>
            <div @click="deleteMppGradeUplog(scop.row.id)">
              <Icon size="16" style="color: red">
                <Delete24Regular />
              </Icon>
              <span class="operation-label" style="color: red">删除</span>
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-box">
      <el-pagination
        @size-change="sizeChange"
        @current-change="currentChange"
        :current-page.sync="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalNum"
        background
        :pager-count="7"
      >
      </el-pagination>
    </div>
    <!-- 新增/查看/修改信息 -->
    <el-dialog
      :title="mppGradeUplogStates[mppGradeUplogState]"
      :visible.sync="showDialog"
      width="60%"
      :append-to-body="true"
      @close="closeDialog"
    >
      <div>
        <el-form
          :model="mppGradeUplog"
          ref="mppGradeUplogForm"
          :rules="rules"
          label-width="120px"
          :inline="true"
          size="small"
        >
          <el-form-item
            label="用户"
            prop="userId"
          >
            <!-- <el-input
              size="small"
              v-model="mppGradeUplog.userId"
              :disabled="mppGradeUplogState == 'check'"
            ></el-input> -->
            <GridSelectU title="选择用户" style="width: 177px;" labelName="userName" :disabled="mppGradeUplogState == 'check'"
              labelValue="id" :value="mppGradeUplog.userId" :limit='1' size='small' placeholder='请选择用户'
              @getValue="getValueUser" :columns="USER_code" :searchs="USER_search" dataListUrl="/mpp/user/findList" entityBeanName="mppUser" queryEntityUrl="/mpp/user/get">
            </GridSelectU>
          </el-form-item>
          <el-form-item
            label="升级前等级"
            prop="originalGradeId"
          >
            <!-- <el-input
              style="width: 177px;"
              size="small"
              v-model="mppGradeUplog.originalGradeId"
              :disabled="mppGradeUplogState == 'check'"
            ></el-input> -->
            <el-select
                style="width: 177px;"
                v-model='mppGradeUplog.originalGradeId'
                :disabled="mppGradeUplogState == 'check'"
                size='small'
                clearable
                placeholder='升级前等级'
            >
                <el-option v-for='(item,index) in mppGradeAll' :label='item.gradeName' :value='item.id'></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="升级后等级"
            prop="upgradeGradeId"
          >
            <!-- <el-input
              size="small"
              style="width: 177px;"
              v-model="mppGradeUplog.upgradeGradeId"
              :disabled="mppGradeUplogState == 'check'"
            ></el-input> -->
            <el-select
                style="width: 177px;"
                v-model='mppGradeUplog.upgradeGradeId'
                :disabled="mppGradeUplogState == 'check'"
                size='small'
                clearable
                placeholder='升级后等级'
            >
                <el-option v-for='(item,index) in mppGradeAll' :label='item.gradeName' :value='item.id'></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="升级模式"
            prop="upgradeMode"
          >
            <!-- <el-input
              size="small"
              style="width: 177px;"
              v-model="mppGradeUplog.upgradeMode"
              :disabled="mppGradeUplogState == 'check'"
            ></el-input> -->
            <el-select
                style="width: 177px;"
                v-model='mppGradeUplog.upgradeMode'
                :disabled="mppGradeUplogState == 'check'"
                size='small'
                placeholder='升级模式'
            >
                <el-option v-for='(item,index) in upgradeModeTypeEnumList' :label='item.value' :value='item.key'></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="支付方式"
            prop="payType"
          >
            <!-- <el-input
              size="small"
              style="width: 177px;"
              v-model="mppGradeUplog.payType"
              :disabled="mppGradeUplogState == 'check'"
            ></el-input> -->
            <el-select
                style="width: 177px;"
                v-model='mppGradeUplog.payType'
                :disabled="mppGradeUplogState == 'check'"
                size='small'
                placeholder='支付方式'
            >
                <el-option v-for='(item,index) in upgradePayUnitTypeEnumList' :label='item.value' :value='item.key'></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="支付单号"
            prop="payNo"
          >
            <el-input
              size="small"
              style="width: 177px;"
              v-model="mppGradeUplog.payNo"
              :disabled="mppGradeUplogState == 'check'"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>

      <div
        slot="footer"
        class="flex justify-end"
      >
        <el-button @click="closeDialog">关闭</el-button>
        <el-button
          type="primary"
          @click="submitForm"
          v-if="mppGradeUplogState != 'check'"
        >确定</el-button>
      </div>
    </el-dialog>
  </div>
  </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun } from '@/utils/request.js';
import GridSelectU from '@/components/gridselect';
import { USER, USER_SEARCH } from '@/utils/constant'
export default {
    components: {
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search,
        GridSelectU
    },
    props: {
      upgradeModeTypeEnumList:{
        type: Array,
      }
    },
        watch: {
            checkState(val) {
                if (val == 'check') {
                    this.resetMppGradeUplogList();
                    this.getMppGradeUplogList(this.queryForm);
                    this.$emit('resetCheckState');
                } else if (val == 'reset') {
                    this.resetMppGradeUplogList();
                    this.getMppGradeUplogList();
                    this.$emit('resetCheckState');
                }
            }
        },
    data() {
            return {
                queryForm:{
                     userId: '', //用户
                     originalGradeId: '', //升级前等级
                     upgradeGradeId: '', //升级后等级
                     upgradeMode: '', //升级模式
                     payType: '', //支付方式
                     payNo: '', //支付单号
                },
                USER_code: USER,
                USER_search: USER_SEARCH,
                loading: false,
                showDialog: false,
                isImportDate: false,
                isSearch: false,
                pageSize: 10,
                currentPage: 1,
                totalNum: 0,
                currentUserId: '',
                mppGradeUplogState: 'add',
                mppGradeUplogStates: {
                    add: '新建mpp_grade_uplog',
                    check: '查看mpp_grade_uplog',
                    edit: '修改mpp_grade_uplog'
                },

                multipleSelection: [],
                mppGradeUplogList: [],
                mppGradeUplog: {
                    id: '', //ID
                    userId: '', //用户
                    originalGradeId: '', //升级前等级
                    upgradeGradeId: '', //升级后等级
                    upgradeMode: '', //升级模式
                    payType: '', //支付方式
                    payNo: '', //支付单号
                },
                btnLoading: false,
                upgradePayUnitTypeEnumList: [],
                rules: {
                    userId: [{ required: true, message: '用户不能为空', trigger: 'blur' }],
                    originalGradeId: [{ required: true, message: '升级前等级不能为空', trigger: 'blur' }],
                    upgradeGradeId: [{ required: true, message: '升级后等级不能为空', trigger: 'blur' }],
                    upgradeMode: [{ required: true, message: '升级模式不能为空', trigger: 'blur' }],
                    payType: [{ required: true, message: '支付方式不能为空', trigger: 'blur' }],
                    payNo: [{ required: true, message: '支付单号不能为空', trigger: 'blur' }],
                },
                mppGradeAll: [], //所有等级
            };
        },
        created() {
            this.getMppGradeUplogList();
            this.getUpgradePayUnitType();
            this.getAll();
        },
        methods: {
            search(){
                this.isSearch = !this.isSearch;
            },
            getSeachValuebrandId(value) {
              this.queryForm.userId = value;
            },
            getValueUser(value) {
              this.mppGradeUplog.userId = value
            },
            // 获取所有等级
            getAll(){
              get('mpp/grade/findAll', {
              }).then((res) => {
                this.mppGradeAll = res.list;
              });
            },
            //升级模块
            getUpgradeModeType(val) {
                for (const iterator of this.upgradeModeTypeEnumList) {
                  if(iterator.key == val){
                    return iterator.value;
                  }
                }
            },
            //获取枚举
            getUpgradePayUnitType() {
                get('/mpp/utils/getEnum', {
                    enumType: 'order_pay_type'
                }).then((res) => {
                    this.upgradePayUnitTypeEnumList = res.enumList;
                });
            },
            componentUpgradePayUnitType(val){
              for (const iterator in this.upgradePayUnitTypeEnumList) {
                if(this.upgradePayUnitTypeEnumList[iterator].key == val){
                  return this.upgradePayUnitTypeEnumList[iterator].value;
                }
              }
            },
            resetMppGradeUplogList() {
                this.pageSize = 10;
                this.currentPage = 1;
                this.mppGradeUplogList = [];
            },
            resetDialog() {
                this.mppGradeUplogState = 'add';
                this.showDialog = false;
                this.queryForm = {
                      userId: '', //用户
                      originalGradeId: '', //升级前等级
                      upgradeGradeId: '', //升级后等级
                      upgradeMode: '', //升级模式
                      payType: '', //支付方式
                      payNo: '', //支付单号
                };
                this.getMppGradeUplogList();
            },
            closeDialog() {
                this.showDialog = false
                this.mppGradeUplog = {
                      id: '', //ID
                      userId: '', //用户
                      originalGradeId: '', //升级前等级
                      upgradeGradeId: '', //升级后等级
                      upgradeMode: '', //升级模式
                      payType: '', //支付方式
                      payNo: '', //支付单号
                };
            },
            submitForm() {
                if (this.mppGradeUplogState == 'add') {
                    this.$refs.mppGradeUplogForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/web/gradeuplog/add`,{ ...this.mppGradeUplog }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000,
                                    });
                                    this.resetMppGradeUplogList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                } else if (this.mppGradeUplogState == 'edit') {
                    this.$refs.mppGradeUplogForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/web/gradeuplog/edit`,{ ...this.mppGradeUplog }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000
                                    });
                                    this.resetMppGradeUplogList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                }
            },
            addMppGradeUplog() {
                this.showDialog = true;
                this.mppGradeUplogState = 'add';
            },
            checkMppGradeUplog(mppGradeUplogId) {
                console.log(mppGradeUplogId);
                this.currentMppGradeUplogId = mppGradeUplogId;

                this.getMppGradeUplogById();
                this.showDialog = true;
                this.mppGradeUplogState = 'check';
            },
            editMppGradeUplog(mppGradeUplogId) {
                console.log('mppGradeUplog', mppGradeUplogId);
                if (mppGradeUplogId) {
                    this.currentMppGradeUplogId = mppGradeUplogId;
                    this.getMppGradeUplogById();
                } else {
                    this.mppGradeUplog = { ...this.mppGradeUplog, ...this.multipleSelection[0] };
                }

                this.showDialog = true;
                this.mppGradeUplogState = 'edit';
            },
            deleteMppGradeUplog(mppGradeUplogId) {
                let ids = '';
                if (mppGradeUplogId) {
                    ids = mppGradeUplogId;
                } else {
                    ids = this.multipleSelection.map((mppGradeUplog) => mppGradeUplog.id).join(',');
                }
                console.log({ ids });
                this.$confirm('确定删除所选项吗？', '提示', {
                    type: 'warning'
                })
                    .then(() => {
                        deleteFun(`/web/gradeuplog/delete`,{ ids }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetMppGradeUplogList();
                                this.getMppGradeUplogList();
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                        });
                    })
                    .catch(() => {});
            },
            refreshMppGradeUplogList() {
                this.resetMppGradeUplogList();
                this.getMppGradeUplogList();
            },
            getMppGradeUplogList(query = {}) {
                this.loading = true;
                get(`/web/gradeuplog/findList`,{  ...this.queryForm, pageNum: this.currentPage, pageSize: this.pageSize }).then((res) => {
                    this.loading = false;
                    if (res.success) {
                        this.mppGradeUplogList = res.page.list;
                        this.totalNum = res.page.total;
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            getMppGradeUplogById() {
                get(`/web/gradeuplog/get`,{ id: this.currentMppGradeUplogId }).then((res) =>{
                    if(res.success){
                      this.mppGradeUplog = { ...this.mppGradeUplog, ...res.mppGradeUplog };
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            /**
             * 导出信息
             */
            exportMppGradeUplogList() {
                //this.btnLoading = true;
                exprotExcel(`/web/gradeuplog/export`, {...this.queryForm});
            },
            /**
             * 导出模板
             */
            importTemplate() {
                this.btnLoading = true;
                importTemplate(`/web/gradeuplog/importTemplate`, this.btnLoading);
            },
            /**
             * 导入数据
             */
            isImport() {
                this.isImportDate = !this.isImportDate;
            },
            upload(params){
              const file = params.file;
              const formData = new FormData();
              formData.append('file', file);
              console.log({ formData });
              importDate(`/web/gradeuplog/importData`,formData);
              this.refreshMppGradeUplogList();
            },
            handleSelectionChange(value) {
                console.log(value);
                this.multipleSelection = value;
            },
            currentChange(page) {
                this.currentPage = page;
                this.getMppGradeUplogList();
            },
            sizeChange(size) {
                this.pageSize = size;
                this.getMppGradeUplogList();
            }
        }

};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
    border-bottom: 1px solid #eee;
}
.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
</style>